import React, {useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Divider from '@material-ui/core/Divider';
// import Autocomplete from '@mui/material/Autocomplete';
//import Autocomplete from '@material-ui/core/Autocomplete';
// import AutoComplete from '@material-ui/AutoComplete';
// import { AutoComplete } from '@material-ui/AutoComplete';
// import { Autocomplete } from '@autocomplete/material-ui';
import {getRussianRegions} from '../../utilities/rusRegions'
import * as ExternWorker from '../../workers/externWorker'
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	alert: {
		backgroundColor: "#f44336",
		color: "white",
		height: "0",
		lineHeight: "3em",
		borderRadius: "0.3em",
		margin: "1em 0 1em 0",
		overflow: "hidden",
		transition: "height 0.4s",
		padding: "0 0 0 1em",
	},
	alertVisible: {
		height: "3em",
	},
	coordWrapper: {
    display: "flex",
    justifyContent: "space-between"
	},
  getCoordButtonWrapper: {
    display: "flex",
    margin: "9px 0 0 0"
  }
}));

export default function EquipDetailsDlg(props) {
  const classes = useStyles();
  const equipName = props.equip?.EquipName;
  const errorFlag = props.error;
  
  const [hospName, setHospName] = React.useState('');
  const [jiraHospName, setJiraHospName] = React.useState('');
  const [equipAlias, setEquipAlias] = React.useState('');
  const [hospitalLatitude, setHospitalLatitude] = React.useState('');
  const [hospitalLongitude, setHospitalLongitude] = React.useState('');
  const [hospAddress, setHospAddress] = React.useState('');
  const [jiraHospAddress, setJiraHospAddress] = React.useState('');
  const [hospitalZones, setHospitalZones] = React.useState('');

  const [city, setCity] = React.useState('');
  const [street, setStreet] = React.useState('');
  const [house, setHouse] = React.useState('');
  const [postalCode, setPostalCode] = React.useState('');
  const [country, setCountry] = React.useState('');

  const [regionsList] = React.useState(getRussianRegions());

  const regions = regionsList?.map(r => r[1]);

  useEffect(() => {
    const equip = props.equip;
    setHospName(equip?.HospitalName);
    setEquipAlias(equip?.EquipAlias);
    setHospitalLatitude(equip?.HospitalLatitude);
    setHospitalLongitude(equip?.HospitalLongitude);
    setHospAddress(equip?.HospitalAddress);
    setHospitalZones(equip?.HospitalZones);
	let address = equip?.HospitalAddress?.split(",");
	if (address !== undefined && address !== null && address.length === 6)
	{
		setPostalCode(address[0]);
		setCountry(address[1]);
		setHospitalZones(address[2]);
		setCity(address[3]);
		setStreet(address[4]);
		setHouse(address[5]);
	}
	else
	{
		setPostalCode('');
		setCountry('');
		setHospitalZones('');
		setCity('');
		setStreet('');
		setHouse('');
	}
	setJiraHospName(equip.JiraLink?.Hospital);
	setJiraHospAddress(equip.JiraLink?.Address);
  }, [props.equip]);

  const handleClose = () => {
    props?.onClose(false);
  };

  const handleCloseOK = () => {
    props?.onClose(true, 
      {
        EquipName: equipName,
        EquipAlias: equipAlias,
        HospitalLatitude: hospitalLatitude,
        HospitalLongitude: hospitalLongitude,
        HospitalName: hospName,
        HospitalAddress: hospAddress,
        HospitalZones: hospitalZones,
      });
  };

  const handleCoordsQuery = async () => {
    //nominatim.openstreetmap.org/search.php?street=проспект+Юрия+Гагарина+32+к6&city=Санкт-Петербург&format=jsonv2

    const coords = await ExternWorker.GetEquipCoords(city, street, house);
    setHospitalLatitude(parseFloat(coords?.[0]?.lat));
    setHospitalLongitude(parseFloat(coords?.[0]?.lon));

//https://nominatim.openstreetmap.org/lookup?osm_ids=W159914288&format=json&accept-language=ru
	const osm_id = coords.find(x => x.osm_type === "way")?.osm_id;
	const addressInfos = await ExternWorker.GetAddressInfo(osm_id);
	const addressInfo = addressInfos[0];
	setPostalCode(addressInfo?.address.postcode);

	if (addressInfo?.address.state.includes("Крым"))
	{
		setCountry("Россия");
		setHospitalZones("Республика Крым");
	}
	else if (addressInfo?.address.state === "Севастополь")
	{
		setCountry("Россия");
		setHospitalZones(addressInfo?.address.state);
	}
	else{
		setCountry(addressInfo?.address.country);
		setHospitalZones(addressInfo?.address.state);
	}
  };  

  const onEquipAliasChange = async (val) =>{
    setEquipAlias(val.target?.value);
  }
  
  const onHospitalLongitudeChange = async (val) => {
    setHospitalLongitude(val.target?.value);
  }

  const onHospitalLatitudeChange = async (val) =>{
    setHospitalLatitude(val.target?.value);
  }

  const onHospitalZonesChange = async (val) =>{
    setHospitalZones(val.target?.innerText);
  }

  const onHospNameChange = async (val) =>{
    setHospName(val.target?.value);
  }

  const onPostalCodeChange = async (val) =>{
    setPostalCode(val.target?.value);
  } 

  const onCountryChange = async (val) =>{
    setCountry(val.target?.value);
  } 

  const onCityChange = async (val) =>{
    setCity(val.target?.value);
  }  

  const onStreetChange = async (val) =>{
    setStreet(val.target?.value);
  }  

  const onHouseChange = async (val) =>{
    setHouse(val.target?.value);
  }  

  useEffect(() => {
	setHospAddress(postalCode+","+country+","+hospitalZones+","+city+","+street+","+house)
   }, [postalCode,country,hospitalZones,city, street, house]);

  return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">
				Карточка оборудования ({equipName})
			</DialogTitle>
			<DialogContent>
				<TextField
					autoFocus
					margin="dense"
					id="alias"
					label="Алиас"
					fullWidth
					variant="standard"
					value={equipAlias}
					onChange={onEquipAliasChange}
				/>

				<TextField
					autoFocus
					margin="dense"
					id="hospital"
					label="Название ЛПУ"
					fullWidth
					variant="standard"
					value={hospName}
					onChange={onHospNameChange}
				/>
				{jiraHospName && (jiraHospName !== hospName || hospAddress?.replace('Адрес', '') === '') ?
				<TextField
					autoFocus
					margin="dense"
					id="hospital"
					label="Название ЛПУ (Jira)"
					fullWidth
					variant="standard"
					value={jiraHospName}
					disabled="disabled"
					multiline
				/> : null}

				<TextField
					autoFocus
					margin="dense"
					id="address"
					label="Адрес ЛПУ"
					fullWidth
					variant="standard"
					value={hospAddress}
					disabled="disabled"
  				/>

				{jiraHospAddress && (hospAddress?.replace('Адрес', '') === '') ?
				<TextField
					autoFocus
					margin="dense"
					id="address"
					label="Адрес ЛПУ (Jira)"
					fullWidth
					variant="standard"
					value={jiraHospAddress}
					disabled="disabled"
					multiline
				/> : null}

				<TextField
					autoFocus
					margin="dense"
					id="postalCode"
					label="Почтовый индекс"
					variant="standard"
					value={postalCode}
					fullWidth
					onChange={onPostalCodeChange}
				/>

				<TextField
					autoFocus
					margin="dense"
					id="country"
					label="Страна"
					variant="standard"
					value={country}
					fullWidth
					onChange={onCountryChange}
				/>
				{/* <div style={{ width: 300 }}> */}
				<Autocomplete
					// {...defaultProps}
					options={regions}
					fullWidth
					id="debug"
					debug
					value={hospitalZones}
					onChange={onHospitalZonesChange}
					renderInput={(params) => (
						<TextField {...params} fullWidth label="Регионы" margin="normal" />
					)}
				/>
				{/* </div> */}
				{/* <TextField
            autoFocus
            margin="dense"
            id="longitude"
            label="Регион"
            fullWidth
            variant="standard"
            value={hospitalZones}
            onChange={onHospitalZonesChange}
          /> */}
				{/*<Autocomplete
            disablePortal
            id="combo-box-demo"
            options={regions}
            fullWidth
            // sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Регионы" />}
          />  */}

				{/* <div style={{ width: 500 }}>
          <Autocomplete
            multiple
            options={top100Films}
          getOptionLabel={option => option.title}
          defaultValue={[top100Films[13]]}
            // options={regions}
            // getOptionLabel={'Регионы'}
            // defaultValue={regions?.[0]}
            // onChange={this.onTagsChange}
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                label="Регионыs"
                placeholder="Регионыv"
                margin="normal"
                fullWidth
              />
            )}
          />
        </div> */}
				<TextField
					autoFocus
					margin="dense"
					id="city"
					label="Город*"
					variant="standard"
					value={city}
					fullWidth
					onChange={onCityChange}
				/>
				<TextField
					autoFocus
					margin="dense"
					id="street"
					label="Улица*"
					variant="standard"
					value={street}
					fullWidth
					onChange={onStreetChange}
				/>
				<TextField
					autoFocus
					margin="dense"
					id="house"
					label="Дом"
					variant="standard"
					value={house}
					fullWidth
					onChange={onHouseChange}
				/>
				<div className={classes.coordWrapper}>
					<TextField
						autoFocus
						margin="dense"
						id="latitude"
						label="Широта"
						fullWidth
						variant="standard"
						value={hospitalLatitude}
						onChange={onHospitalLatitudeChange}
						style={{ margin: "0 10px 0 0" }}
					/>
					<TextField
						autoFocus
						margin="dense"
						id="longitude"
						label="Долгота"
						fullWidth
						variant="standard"
						value={hospitalLongitude}
						onChange={onHospitalLongitudeChange}
						style={{ margin: "0 10px 0 0" }}
					/>
					<div className={classes.getCoordButtonWrapper}>
						<Button
							variant="contained"
							color="primary"
							onClick={handleCoordsQuery}>
							Запросить
						</Button>
					</div>
				</div>
				<div
					className={`${classes.alert} ${
						errorFlag ? classes.alertVisible : ""
					}`}>
					Некорректные значения широты и долготы.
				</div>
			</DialogContent>
			<DialogActions>
				<Button
					variant="contained"
					color="primary"
					onClick={handleCloseOK}
					autoFocus>
					Применить
				</Button>
				<Button variant="contained" color="secondary" onClick={handleClose}>
					Отмена
				</Button>
			</DialogActions>
		</Dialog>
	);
}